<template>
  <div class="phonePage02" :style="bg">
    <div class="pt_area">
      <div class="pt_title">{{ title }}</div>
      <!-- <div class="pt_line"></div>
      <div class="pt_label">NEWS</div> -->
    </div>
    <van-swipe class="my-swipe" :autoplay="0" indicator-color="white" @change="onChange" ref="indicator">
      <van-swipe-item v-for="item in $tools.localStorageFn
        .get('PAGE_DATE')
        .dynamicList.slice(0, 3)" :key="item.id">
        <div class="dynamicBox">
          <div class="left" :style="'background: url(' +
            imgUrl +
            $tools.localStorageFn.get('PAGE_DATE').banner1_lef +
            ') no-repeat center center'
            ">
            <p>京哲动态</p>
            <h2>{{ item.title }}</h2>
            <button @click="$router.push('/mobileJingzheDynamic')">
              了解更多
            </button>
          </div>
          <div class="right">
            <div class="dynamicItem">
              <div class="date">{{ item.created_at }}</div>
              <div class="label">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">
          <div class="pt_point" v-for="(item, index) in $tools.localStorageFn
            .get('PAGE_DATE')
            .dynamicList.slice(0, 3)" :key="index" :class="current == index ? 'pt_point_active' : ''" @click="() => {
    $refs.indicator.swipeTo(index);
  }
    "></div>
        </div>
      </template>
    </van-swipe>
    <floatService style="position: absolute;"></floatService>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: {
        background:
          "url(" +
          this.$tools.localStorageFn.get("PAGE_DATE").banner1 +
          ") no-repeat center center",
      },
      title: '',
      current: 0,
    };
  },
  created() {
    this.getTitle(47)
  },
  methods: {
    // 轮播变化
    onChange(index) {
      this.current = index;
    },

    getTitle(id) {
      this.$tools.localStorageFn.get("CATEGORIES_LIST").forEach((item) => {
        if (item.id == id) {
          console.log('item', item)
          this.title = item.title;
        } else if (item.children.length > 0) {
          item.children.forEach((ele) => {
            console.log('ele', ele)
            if (ele.id == id) {
              this.title = ele.title;
            }
          })
        }
      })
    },
  },
};
</script>

<style lang="scss">
.phonePage02 {
  height: 100%;
  width: 100%;
  // background: url(~@/assets/images/phoneBg02.png) no-repeat center center;
  background-size: 100% 100% !important;
  position: relative;
  padding-top: 17.05vh;

  .pt_area {
    width: 100%;
    margin-bottom: 4.88vh;

    .pt_title {
      font-size: 3.2rem;
      font-family: JingZhe_XiaoWei;
      font-weight: 400;
      color: #013060;
      text-align: center;
    }

    .pt_line {
      width: 5.9rem;
      height: 0.2rem;
      background: #013060;
      margin: 0.7rem auto 0.9rem;
    }

    .pt_label {
      font-size: 1.4rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #013060;
      text-align: center;
    }
  }

  .my-swipe {
    transform: translateX(-6.0rem);
    opacity: 0;
    transition: 1s 0.7s;
    overflow: visible;
    position: relative;

    .van-swipe-item {
      .dynamicBox {
        justify-content: center;
        padding: 1.6rem;

        .left {
          height: 21.8rem;
          width: 100%;
          background-size: cover !important;
          padding: 1.6rem;

          p {
            margin: 0;
            font-size: 1.6rem;
            font-family: SimHei;
            font-weight: 400;
            color: #013060;
          }

          h2 {
            margin: 0;
            margin-top: 1.2rem;
            font-size: 1.4rem;
            font-family: SimHei;
            font-weight: 400;
            color: #013060;
          }

          button {
            padding: 0;
            cursor: pointer;
            margin-top: 0.3rem;
            width: 7.2rem;
            height: 4.8rem;
            background: url(~@/assets/images/icon_liaojiegengduo.png) no-repeat center center;
            background-size: 100%;
            font-size: 1.2rem;
            font-family: SimHei;
            font-weight: 400;
            color: #013060;
            line-height: 4.8rem;
            text-align: center;
            position: relative;
            transition: 0.6s;
            border: 0;
          }

          button:hover {
            color: #fff;
            background: url(~@/assets/images/icon_liaojiegengduo02.png) no-repeat center center;
            background-size: 100%;
          }
        }

        .right {
          width: 100%;

          .dynamicItem {
            cursor: pointer;
            height: 100%;
            padding: 1.6rem;
            background: #013060;

            .date {
              font-size: 1.2rem;
              font-family: SimHei;
              font-weight: 400;
              color: #ffffff;
            }

            .label {
              margin-top: 1.2rem;
              font-size: 1.4rem;
              font-family: SimHei;
              font-weight: 400;
              color: #ffffff;
            }
          }

          .selected {
            background: #01407e;
          }

          .dynamicItem:hover {
            background: #01407e;
          }
        }
      }
    }

    .custom-indicator {
      display: flex;
      position: absolute;
      bottom: -2.4rem;
      left: 50%;
      transform: translateX(-50%);

      .pt_point {
        width: 0.9rem;
        height: 0.9rem;
        background: #c3c3c3;
        border-radius: 0.4rem;
        margin-right: 0.7rem;
      }

      .pt_point_active {
        width: 2.3rem;
        height: 0.9rem;
        background: #013060;
        border-radius: 0.4rem;
      }
    }
  }
}

.active {
  .phonePage02 {
    .pt_title {
      animation: fade-in-top96 1.7s ease 0s 1 normal none;
    }

    .my-swipe {
      transform: translate(0);
      opacity: 1;
    }
  }
}
</style>